<template>
  <list
    model-name="pinkfongproducts"
    :items-url="URL"
    :params="params"
    :flex-class="padding"
    :list-break-point="pinkfongBreakpoint"
    :empty-mark-enable="true"
  >
    <template slot-scope="props">
      <h3>{{ props.item.name }}</h3>
      <div class="mt-1">
        Item Code: {{ props.item.uid }}<br>
        <div v-if="isKorean()">
          {{ $t("variables.price") }}: {{ $t("variables.currencyCode") }}{{ Number(props.item.price).toLocaleString() }}
        </div>
        <v-btn
          style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
          @click.stop="linkTo(getDetailUrl(props.item))"
        >
          {{ $t("variables.viewDetail") }}
        </v-btn>
      </div>
    </template>
  </list>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import List from 'components/List.vue'

export default {
  directives: { infiniteScroll },
  components: {
    'list': List
  },
  data () {
    return {
      URL: '/api/products/pinkfongproducts/',
      items: [],
      nextLink: ''
    }
  },
  computed: {
    pinkfongBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    params () {
      return { category: this.$route.params.category }
    },
    padding () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md': return 'pa-3'
        default: return 'pa-2'
      }
    },
    outerPadding () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm': return 'px-4'
        default: return ''
      }
    }
  },
  methods: {
    getDetailUrl (item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/pinkfongproducts/' + category + '/' + item.code
    },
    linkTo (address) {
      this.$router.push(address)
    }
  }
}
</script>

<style>
#selected-products-empty{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  flex-direction: column;
}

#selected-products-empty #selected-products-empty-title{
  padding-top: 30px;
  margin: 0px;
  font-size: 24px;
  color: rgba(146, 146, 146, 0.9)
}
</style>



// WEBPACK FOOTER //
// src/app/contents/PinkfongProductList.vue